/** App-wide display format: 23/07/2026 (DD/MM/YYYY) */

const pad2 = (n) => String(n).padStart(2, "0");

const parseToParts = (rawDate) => {
  if (rawDate == null || rawDate === "") return null;

  if (rawDate instanceof Date && !Number.isNaN(rawDate.getTime())) {
    return {
      day: rawDate.getDate(),
      month: rawDate.getMonth() + 1,
      year: rawDate.getFullYear(),
    };
  }

  const value = String(rawDate).trim();
  if (!value) return null;

  // YYYY-MM-DD (HTML date input / ISO prefix)
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split("-").map(Number);
    return { day, month, year };
  }

  const parts = value.split(/[./-]/);
  if (parts.length === 3) {
    // DD.MM.YYYY or DD/MM/YYYY or DD-MM-YYYY
    if (parts[0].length <= 2 && parts[2].length === 4) {
      const [day, month, year] = parts.map(Number);
      return { day, month, year };
    }
    // YYYY/MM/DD
    if (parts[0].length === 4) {
      const [year, month, day] = parts.map(Number);
      return { day, month, year };
    }
    // M-D-YYYY (en-US legacy)
    if (parts[2].length === 4) {
      const [month, day, year] = parts.map(Number);
      if (month >= 1 && month <= 12) {
        return { day, month, year };
      }
    }
  }

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return {
      day: parsed.getDate(),
      month: parsed.getMonth() + 1,
      year: parsed.getFullYear(),
    };
  }

  return null;
};

/** Format for UI / storage: DD/MM/YYYY */
export const toDisplayDate = (rawDate) => {
  const parts = parseToParts(rawDate);
  if (!parts || !parts.year || !parts.month || !parts.day) return "";
  return `${pad2(parts.day)}/${pad2(parts.month)}/${parts.year}`;
};

/** Format for <input type="date">: YYYY-MM-DD */
export const toInputDate = (rawDate) => {
  const parts = parseToParts(rawDate);
  if (!parts || !parts.year || !parts.month || !parts.day) return "";
  return `${parts.year}-${pad2(parts.month)}-${pad2(parts.day)}`;
};

export const todayDisplayDate = () => toDisplayDate(new Date());

/** Returns a Date at local midnight, or null if unparseable */
export const toComparableDate = (rawDate) => {
  const parts = parseToParts(rawDate);
  if (!parts || !parts.year || !parts.month || !parts.day) return null;
  return new Date(parts.year, parts.month - 1, parts.day);
};
